import { mapState, mapMutations, mapGetters } from 'vuex'
import { getUserInfo, queryBindStatus } from "@api/user";
export default {
    props: {},
    computed: {
        ...mapState(['app']),
        ...mapGetters(['token', 'userInfo'])
    },
    data() {
        return {
            Images: this.Images,
            Constants: this.Constants,

            bindAccount: 0,
            bindAccountTips: '为方便月底结算发放奖金，请您立即绑定打款账号',
            showingAccountAlert: false,
        }
    },
    mounted() {
        // console.log('this.userInfo---->', this.userInfo);
        // setTimeout(() => this._onHideLoading(), 1000);
    },
    methods: {
        ...mapMutations(['SHOW_LOADING', 'HIDE_LOADING']),

        _onShowLoading() {
        	this.SHOW_LOADING();
        },

        _onHideLoading() {
        	this.HIDE_LOADING();
        },

        // 查询结算账号绑定状态
        async _onQueryBindAccount(showingAccountAlert = true) {
            if (!this.token) return;
            let result = await queryBindStatus()
            console.log('result---->', result);
            if (result.status == 200) {
                this.bindAccountTips = result.msg;
                this.bindAccount = result.data.is_bind;
                showingAccountAlert && this.bindAccount < 1 && this._onShowAlertVerify();
            }
        },

        _onShowAlertVerify(callback) {
            if (!this.token) {
                this.$dialog.toast({ mes: "请先登录" });
                return this.$router.push("/login");
            }
            if (this.showingAccountAlert) return;
            this.showingAccountAlert = true;
            this.$dialog.confirm({
            	title: '温馨提示',
                mes: this.bindAccountTips,
                opts: [
                    {
                        txt: "暂不设置",
                        color: false,
                        callback: () => {
                        	callback && callback();
                        	this.showingAccountAlert = false;
                        }
                    },{
                        txt: "立即设置",
                        callback: () => {
                        	this.showingAccountAlert = false;
                            this.goToBindAccount();
                        }
                    }
                ]
            });

        },

        // 去绑定结算账号
        goToBindAccount() {
            this.$router.push("/bindAccount");
        },
    }

}